import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import ErrorBoundary from 'components/ErrorBoundary';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));

// render - color
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));

// render - custom pages
const MasterAnggota = Loadable(lazy(() => import('pages/master/anggota')));
const MasterPembayaran = Loadable(lazy(() => import('pages/master/pembayaran')));
const MasterAkun = Loadable(lazy(() => import('pages/master/User')));
const MasterKategoriBarang = Loadable(lazy(() => import('pages/master/KategoriBarang')));
const MasterSatuanBarang = Loadable(lazy(() => import('pages/master/SatuanBarang')));
const MasterBarang = Loadable(lazy(() => import('pages/master/Barang')));
const MasterTarif = Loadable(lazy(() => import('pages/master/Tarif')));
const MasterCustomer = Loadable(lazy(() => import('pages/master/Customer')));
const MasterSupplier = Loadable(lazy(() => import('pages/master/Supplier')));
const MasterKendaraan = Loadable(lazy(() => import('pages/master/Kendaraan')));
const MasterJabatan = Loadable(lazy(() => import('pages/master/Jabatan')));
const MasterKaryawan = Loadable(lazy(() => import('pages/master/Karyawan')));
const MasterPerusahaan = Loadable(lazy(() => import('pages/master/Perusahaan')));
const MasterGudang = Loadable(lazy(() => import('pages/master/Gudang')));
const MasterGudangCustomer = Loadable(lazy(() => import('pages/master/GudangCustomer')));
const MasterGudangSupplier = Loadable(lazy(() => import('pages/master/GudangSupplier')));
const GudangStok = Loadable(lazy(() => import('pages/gudang/Stok')));
const BarangMasuk = Loadable(lazy(() => import('pages/gudang/BarangMasuk')));
const DaftarBarangMasuk = Loadable(lazy(() => import('pages/gudang/DaftarBarangMasuk')));
const BarangKeluar = Loadable(lazy(() => import('pages/gudang/BarangKeluar')));
const GudangInvoice = Loadable(lazy(() => import('pages/gudang/Invoice')));
const DaftarBarangKeluar = Loadable(lazy(() => import('pages/gudang/DaftarBarangKeluar')));
const StokOpname = Loadable(lazy(() => import('pages/gudang/StokOpname')));
const PersetujuanOpname = Loadable(lazy(() => import('pages/gudang/PersetujuanOpname')));
const CetakStokOpname = Loadable(lazy(() => import('pages/gudang/CetakStokOpname')));
const LaporanStokOpname = Loadable(lazy(() => import('pages/gudang/LaporanStokOpname')));
const LaporanBarangMasuk = Loadable(lazy(() => import('pages/gudang/LaporanBarangMasuk')));
const LaporanBarangKeluar = Loadable(lazy(() => import('pages/gudang/LaporanBarangKeluar')));
const LaporanMutasiStok = Loadable(lazy(() => import('pages/gudang/LaporanMutasiStok')));
const LaporanAuditStok = Loadable(lazy(() => import('pages/gudang/LaporanAuditStok')));
const CetakDaftarBarang = Loadable(lazy(() => import('pages/gudang/CetakDaftarBarang')));
const InputTransaksi = Loadable(lazy(() => import('pages/transaksi/input')));
const InputPengeluaran = Loadable(lazy(() => import('pages/transaksi/pengeluaran')));
const DaftarTransaksi = Loadable(lazy(() => import('pages/transaksi/daftar')));
const TarikPembayaran = Loadable(lazy(() => import('pages/laporan/tarik-pembayaran')));
const QrcodeLaporan = Loadable(lazy(() => import('pages/laporan/qrcode')));

// render - produksi
const ProsesProduksi = Loadable(lazy(() => import('pages/produksi/ProsesProduksi')));
const ProsesProduksiForm = Loadable(lazy(() => import('pages/produksi/ProsesProduksiForm')));
const FinishGood = Loadable(lazy(() => import('pages/produksi/FinishGood')));
const FinishGoodForm = Loadable(lazy(() => import('pages/produksi/FinishGoodForm')));
const LaporanFinishGood = Loadable(lazy(() => import('pages/produksi/LaporanFinishGood')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <DashboardLayout />,
  errorElement: <ErrorBoundary />,
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'typography',
      element: <Typography />
    },
    {
      path: 'color',
      element: <Color />
    },
    {
      path: 'shadow',
      element: <Shadow />
    },
    {
      path: 'sample-page',
      element: <SamplePage />
    },
    {
      path: 'master',
      children: [
        {
          path: 'anggota',
          element: <MasterAnggota />
        },
        {
          path: 'pembayaran',
          element: <MasterPembayaran />
        },
        {
          path: 'akun',
          element: <MasterAkun />
        },
        { path: 'kategori_barang', element: <MasterKategoriBarang /> },
        { path: 'satuan_barang', element: <MasterSatuanBarang /> },
        { path: 'barang', element: <MasterBarang /> },
        { path: 'tarif', element: <MasterTarif /> },
        { path: 'customer', element: <MasterCustomer /> },
        { path: 'supplier', element: <MasterSupplier /> },
        { path: 'kendaraan', element: <MasterKendaraan /> },
        { path: 'jabatan', element: <MasterJabatan /> },
        { path: 'karyawan', element: <MasterKaryawan /> },
        { path: 'perusahaan', element: <MasterPerusahaan /> },
        { path: 'gudang', element: <MasterGudang /> },
        { path: 'gudang-customer', element: <MasterGudangCustomer /> },
        { path: 'gudang-supplier', element: <MasterGudangSupplier /> }
      ]
    },
    {
      path: 'gudang',
      children: [
        {
          path: 'stok',
          element: <GudangStok />
        },
        {
          path: 'masuk',
          element: <BarangMasuk />
        },
        {
          path: 'masuk/edit/:id',
          element: <BarangMasuk />
        },
        {
          path: 'daftar-masuk',
          element: <DaftarBarangMasuk />
        },
        {
          path: 'keluar',
          element: <BarangKeluar />
        },
        {
          path: 'keluar/edit/:id',
          element: <BarangKeluar />
        },
        {
          path: 'invoice',
          element: <GudangInvoice />
        },
        {
          path: 'invoice/create',
          element: <GudangInvoice />
        },
        {
          path: 'invoice/*',
          element: <GudangInvoice />
        },
        {
          path: 'daftar-keluar',
          element: <DaftarBarangKeluar />
        },
        {
          path: 'opname',
          element: <StokOpname />
        },
        {
          path: 'persetujuan-opname',
          element: <PersetujuanOpname />
        },
        {
          path: 'cetak-daftar-barang',
          element: <CetakDaftarBarang />
        },
        {
          path: 'cetak-opname',
          element: <CetakStokOpname />
        },
        {
          path: 'laporan-opname',
          element: <LaporanStokOpname />
        },
        {
          path: 'laporan-masuk',
          element: <LaporanBarangMasuk />
        },
        {
          path: 'laporan-keluar',
          element: <LaporanBarangKeluar />
        },
        {
          path: 'laporan-mutasi',
          element: <LaporanMutasiStok />
        },
        {
          path: 'laporan-audit',
          element: <LaporanAuditStok />
        }
      ]
    },
    {
      path: 'transaksi',
      children: [
        {
          path: 'input',
          element: <InputTransaksi />
        },
        {
          path: 'pengeluaran',
          element: <InputPengeluaran />
        },
        {
          path: 'daftar',
          element: <DaftarTransaksi />
        }
      ]
    },
    {
      path: 'laporan',
      children: [
        {
          path: 'tarik-pembayaran',
          element: <TarikPembayaran />
        },
        {
          path: 'qrcode',
          element: <QrcodeLaporan />
        }
      ]
    },
    {
      path: 'produksi',
      children: [
        {
          path: 'proses',
          element: <ProsesProduksi />
        },
        {
          path: 'proses/tambah',
          element: <ProsesProduksiForm />
        },
        {
          path: 'proses/edit/:id',
          element: <ProsesProduksiForm />
        },
        {
          path: 'finish-good',
          element: <FinishGood />
        },
        {
          path: 'finish-good/tambah',
          element: <FinishGoodForm />
        },
        {
          path: 'finish-good/edit/:id',
          element: <FinishGoodForm />
        },
        {
          path: 'laporan-finish-good',
          element: <LaporanFinishGood />
        }
      ]
    }
  ]
};

export default MainRoutes;
